import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Section } from '@taxora-shared-common/ui/section/section';
import { FallbackValuePipe } from '@taxora-shared-common/util';
import { Button } from 'primeng/button';

export interface ProfileDetailsValue {
  photoUrl: string | null;
  fullName: string | null;
  email: string | null;
  phone: string | null;
  role: string | null;
  language: string | null;
  activePlan: string | null;
}

@Component({
  selector: 'lib-profile-details',
  standalone: true,
  imports: [CommonModule, TranslatePipe, Button, FallbackValuePipe, Section],
  templateUrl: './profile-details.html',
  styleUrl: './profile-details.scss',
})
export class ProfileDetails {
  public readonly value = input<ProfileDetailsValue | null>(null);
  public readonly editProfile = output<void>();
  public readonly changePhoto = output<void>();
  public readonly changePassword = output<void>();
  public readonly changePlan = output<void>();
  protected readonly TRANSLATION_PATH = 'common.profileDetails.';
}
